import { formatURIComponent } from "./utils"

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=humanResource&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '华美服务 = 咨询服务 + 华美云 + 尽管问',
        pageTitle: '人资优化',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        description: `在酒店人力资源管理领域，真正的问题往往隐藏在表面效率之下——比如排班存在大量工时冗余，团队因激励不足而暗藏离职风险，培训体系完善但未能匹配实际业务需求。华美通过科学的岗位分析重构组织架构，运用智能排班系统实现人力配置最优化，同时建立完善的培训体系和激励机制。`,
        icons: [
            {
                name: '人资优化',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/11.人资优化.pdf'),
                path: "四库赋能-酒店资管/人资优化/成功案例"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店资管/人资优化/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/人资优化/数据赋能'),
                path: "四库赋能-酒店资管/人资优化/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/人资优化/全球案例/全球案例（人资优化）.xlsx'),
                path: "四库赋能-酒店资管/人资优化/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/人资优化/预警问题/预警问题（人资优化）.xlsx'),
                path: "四库赋能-酒店资管/人资优化/预警问题"
            },
        ]
    }]
}